import axios from 'axios'
import routes from './routes/routes'
let api = axios.create()

api.interceptors.request.use(
    config => {
        config.headers['AuthToken'] = localStorage.getItem('access')
        return config
    },
    error => {
        console.log(error)
    }
)
api.interceptors.response.use(
    response => {
        return response
    },
    error => {
        console.log(error)
        if(error.code != "ERR_NETWORK") {
            if(error.response.status === 403) {
                axios.post('https://dev.fly7.ru/mb600/hs/dash/login/refresh_token', {
                    refresh: localStorage.getItem('refresh')
                })
                .then(response => {
                    localStorage.setItem('access', response.data.access)
                    localStorage.setItem('refresh', response.data.refresh);
                })
                .catch(error => {
                    console.log(error)
                    routes.push('/')
                })
            }
        }
        return error
    }
)

export default api